import router from './router'
import WarehouseMessages from './localization'

export default {
  router,
  localization: WarehouseMessages,
}
